import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';
import getDifferenceBetweenDateYearsDays
  from '@/services/general/getDifferenceBetweenDateYearsDays';
import { ANNEE, JOUR } from '@/configuration/devisConf';
import decimalsFormater from '@/services/general/decimalsFormater';
import calculArrondi from '@/services/calcul/calculArrondi';

export function setPrixUnitaireTlpe(listProduitTlpe, liaisonsTarif) {
  listProduitTlpe.forEach((produitTlpe) => {
    const liaisonOfProduct = liaisonsTarif.find((liaison) => {
      return liaison.produitEnfantId === produitTlpe.produitId;
    });
    if (liaisonOfProduct && liaisonOfProduct.prixUnitaire) {
      produitTlpe.prixUnitaire = liaisonOfProduct.prixUnitaire;
    } else if (produitTlpe.produit.produitDivers.prixUnitaire) {
      produitTlpe.prixUnitaire = produitTlpe.produit.produitDivers.prixUnitaire;
    }
  });
}

export function updateTarifProduitDiversTlpe(dateDebut, dateFin, listeProduitDiversTlpe) {
  listeProduitDiversTlpe.forEach((produitTlpe) => {
    const difference = getDifferenceBetweenDateYearsDays(dateDebut, dateFin);
    if (difference.years > 0 && difference.days === 0) {
      produitTlpe.quantite = difference.years;
      produitTlpe.uniteVente = ANNEE;
    } else {
      produitTlpe.prixUnitaire = calculArrondi(
        Number(decimalsFormater(produitTlpe.prixUnitaire / 365)), 5,
      );
      produitTlpe.quantite = Number(calculDaysBetweenTwoDate(dateFin, dateDebut)) + 1;
      produitTlpe.uniteVente = JOUR;
    }
  });
}
